import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="test-script--search"
export default class extends Controller {
  submit (event) {
    this.element.requestSubmit()
  }
}
